const $ = jQuery.noConflict();
'use strict';

const ProductAddToCart = {
	quantity: [],
	debounceTimers: {},
	cartData: [],

	init: function() {
		const _this = this;
		$(document).ready(function() {
			if (typeof window.CartData !== 'undefined') {
				_this.cartData = window.CartData.items;
				_this.cartData.forEach(function(cartItem) {
					_this.quantity[cartItem.sku] = parseInt(cartItem.quantity);
				});
			}

			_this.addButtonListeners();
			_this.addVariationChangeListeners();
		});
	},

	addVariationChangeListeners: function() {
		const _this = this;
		$('#sku-selection').on('change', function() {
			const selectedVariantSku = $(this).data('product-sku');
			if (selectedVariantSku) {
				const button = $('.product-questions__btn-wrapper .js-add-to-inquiry');
				if (button) {
					if (_this.quantity[selectedVariantSku]) {
						_this.updateText(button, _this.quantity[selectedVariantSku] + ' Added', selectedVariantSku);
						_this.addQuantityEvents(selectedVariantSku, button);
					} else {
						_this.updateText(button, 0 + ' Added', selectedVariantSku);
						_this.addToInquiryEvents(selectedVariantSku, button);
					}
				}
			}
		});
	},

	/**
	 * @description Adds event listeners to add-to-cart button
	 */
	addButtonListeners: function() {
		const _this = this;
		$('.js-add-to-inquiry').each(function() {
			const button = $(this);
			const productSku = button.data('product_sku');
			if (button.hasClass('js-added') && button.data('current-count')) {
				_this.quantity[productSku] = parseInt(button.data('current-count'));
				_this.addQuantityEvents(productSku, button);
			} else {
				_this.addToInquiryEvents(productSku, button);
			}
		});
	},

	addToInquiryEvents: function(productSku, button) {
		const _this = this;
		button.off('click').on('click', function(e) {
			e.preventDefault();
			const loader = button.parent().parent().find('.js-loader-button');
			if (!productSku || _this.quantity[productSku] > 0) return;
			_this.quantity[productSku] = 1;
			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'add-to-cart',
					productSku: productSku,
				},
				beforeSend: function() {
					if (loader) {
						loader.addClass('is-active');
					}
				},
				success: function(response) {
					if (response.success) {
						_this.updateText(button, _this.quantity[productSku] + ' Added', productSku);
						_this.quantity[productSku] === 0 ? _this.addToInquiryEvents(productSku, button) : _this.addQuantityEvents(productSku, button);
						if (response?.data?.cart_count !== undefined && response?.data?.cart_count !== null) {
							_this.updateCartTotalText(response.data.cart_count);
						}
					}
				},
				complete: function() {
					if (loader) {
						loader.removeClass('is-active');
					}
				},
			});
		});
	},

	addQuantityEvents: function(productSku, button) {
		const _this = this;
		const parent = button.parent();
		parent.find('.js-inquiry-increase, .js-inquiry-decrease').each(function() {
			const clickedButton = $(this);
			clickedButton.off('click').on('click', function(e) {
				e.preventDefault();

				const loader = clickedButton.parent().parent().find('.js-loader-button');

				if (clickedButton.hasClass('js-inquiry-increase')) {
					_this.quantity[productSku]++;
				} else if (_this.quantity[productSku] > 0) {
					_this.quantity[productSku]--;
				}
				_this.updateText(button, _this.quantity[productSku] + ' Added', productSku);

				if (_this.debounceTimers[productSku]) {
					clearTimeout(_this.debounceTimers[productSku]); // Clear only the timer for this product
				}

				_this.debounceTimers[productSku] = setTimeout(function() {
					$.ajax({
						type: 'POST',
						url: window.fwsLocalized.ajaxUrl,
						data: {
							action: 'update-cart-by-product-sku',
							productSku: productSku,
							quantity: _this.quantity[productSku],
						},
						beforeSend: function() {
							if (loader) {
								loader.addClass('is-active');
							}
						},
						success: function(response) {
							if (response.success) {
								_this.updateText(button, _this.quantity[productSku] + ' Added', productSku);
								if (response?.data?.cart_count !== undefined && response?.data?.cart_count !== null) {
									_this.updateCartTotalText(response.data.cart_count);
								}
							}
						},
						complete: function() {
							if (loader) {
								loader.removeClass('is-active');
							}
						},
					});

					delete _this.debounceTimers[productSku];
				}, 1000);
			});
		});
	},

	updateCartTotalText: function(newTotal) {
		const totalCounter = $('.js-nav-cart-sum');
		totalCounter.text(newTotal);
		totalCounter.removeClass('hidden-element');
	},

	updateText: function(button, newText, productSku) {
		const _this = this;
		if (button.length) {
			const parent = button.parent();
			const decreaseButton = parent.find('.js-inquiry-decrease').first();
			const increaseButton = parent.find('.js-inquiry-increase').first();
			if (decreaseButton.length && increaseButton.length) {
				if (_this.quantity[productSku] > 0) {
					decreaseButton.addClass('is-active');
					increaseButton.addClass('is-active');
				} else {
					decreaseButton.removeClass('is-active');
					increaseButton.removeClass('is-active');
				}
			}

			button.addClass('fade-out');
			setTimeout(() => {
				if (_this.quantity[productSku] > 0) {
					button.text(newText).removeClass('fade-out').addClass('fade-in');
				} else {
					button.text('Add To Inquiry').removeClass('fade-out').addClass('fade-in');
				}
			}, 200);
		}
	},
};

export default ProductAddToCart;
